import React from "react";

function Logo({ className = "", error, short }) {
	let fontSize = "text-2xl";

	if (short) {
		fontSize = "text-sm";
	}

	return (
		<div className={`align-center font-bold ${fontSize} ${className}`}>
			{short ? <img src="https://cdn.travelwings.com/assets/corp/images/logo_short.png" alt="logo" className="max-w-10" /> : <img src="https://cdn.travelwings.com/assets/corp/images/logo.png" alt="logo" className="max-w-48" />}
		</div>
	);
}

export default Logo;
